var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkdin 1",
    clipPath: "url(#clip0_137_54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.58868 2.94471C1.30258 2.91721 1.03061 2.8073 0.80574 2.6283C0.580872 2.4493 0.412758 2.2089 0.321805 1.93626C0.230852 1.66361 0.220945 1.37044 0.293308 1.09229C0.36567 0.814133 0.517186 0.562956 0.729472 0.369203C0.941759 0.175449 1.20572 0.047436 1.48931 0.000713333C1.7729 -0.0460093 2.06397 -0.00944091 2.32719 0.105971C2.59042 0.221382 2.81449 0.410681 2.97225 0.65092C3.13003 0.891159 3.21472 1.17203 3.21604 1.45944C3.21924 1.66885 3.17773 1.87652 3.09428 2.06861C3.01084 2.26071 2.88735 2.4328 2.7321 2.57338C2.57685 2.71396 2.39342 2.81979 2.19401 2.88383C1.9946 2.94786 1.78382 2.96861 1.57575 2.94471H1.58868ZM3.02227 12.6829H0.167969V4.10709H3.02227V12.6829ZM13.3546 12.6829H10.4228V8.11089C10.4228 6.96141 9.99664 6.17357 8.97632 6.17357C8.65479 6.175 8.3414 6.27475 8.07821 6.45944C7.81502 6.64414 7.61462 6.90493 7.50394 7.20681C7.43709 7.43746 7.40662 7.67712 7.41356 7.91716V12.6959H4.57214C4.57214 4.9466 4.57214 4.12002 4.57214 4.12002H7.41356V5.41156C7.66733 4.95437 8.0434 4.57688 8.49963 4.32139C8.95587 4.0659 9.47423 3.94249 9.99665 3.96502C11.8694 3.96502 13.2771 5.25656 13.2771 7.83965L13.3546 12.6829Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.29,
    height: 12.6959,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin1);
export default __webpack_public_path__ + "static/media/linkdin 1.af5ed6d7f59194911d214aa58b2ac9a1.svg";
export { ForwardRef as ReactComponent };